export const dateFormats = {
    dateTime: "yyyy-MM-dd HH:mm:ss",
    date: "yyyy-MM-dd"

}

export const momentFormats={
    dateTime: "YYYY-MM-DD HH:mm:ss",
    date: "YYYY-MM-DD"
}